module.exports = __webpack_public_path__ + "img/step1-img1.85f60c6f.png";